import { CommentList_AnswerFragment } from '@/graphql/generated';
import { DownloadIcon, QuoteIcon } from '@/components/icons';
import { utils, writeFileXLSX } from 'xlsx';
import { TooltipWrapper } from '@/components/generic/TooltipWrapper';
import { useTranslation } from '@/hooks/useTranslation';

export function CommentList({
  answers,
}: {
  answers: CommentList_AnswerFragment[];
}) {
  const { t } = useTranslation();
  const hasComment = (
    comment: string | null | undefined,
  ): comment is string => {
    return !!comment;
  };

  const comments = answers
    .map((answer) => answer.comment)
    .filter((comment) => hasComment(comment));

  if (comments.length === 0) {
    return null;
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between gap-4">
        <h6>{t('survey.responses.comments.title')}</h6>
        <ExportCommentsToXlsButton answers={answers} />
      </div>
      <div className="space-y-2">
        {comments.map((comment, index) => (
          <div key={index} className="space-y-2">
            <div className="flex items-start gap-2">
              <QuoteIcon className="shrink-0 text-gray-300" />
              <div className="bg-white p-2 sami-body-small border-l-2 border-gray-100">
                {comment}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function ExportCommentsToXlsButton({
  answers,
}: {
  answers: CommentList_AnswerFragment[];
}) {
  const { t } = useTranslation();
  const exportToXls = () => {
    const worksheet = utils.json_to_sheet(
      answers
        .filter((answer) => answer.comment)
        .map((answer) => {
          return { Commentaire: answer.comment };
        }),
    );

    const workbook = utils.book_new();
    utils.book_append_sheet(
      workbook,
      worksheet,
      t('survey.responses.comments.export.sheet'),
    );
    writeFileXLSX(
      workbook,
      `${t('survey.responses.comments.export.filename')}.xlsx`,
      {
        compression: true,
      },
    );
  };

  return (
    <TooltipWrapper label={t('survey.responses.comments.export.label')}>
      <button className="tertiary" onClick={exportToXls}>
        <DownloadIcon />
      </button>
    </TooltipWrapper>
  );
}
